<template>
  <v-container fluid class="px-4">
    <v-row justify="center">
      <v-col cols="12" md="8" lg="11">
        <v-tabs
          align-tabs="center"
          fixed-tabs
          background-color="#E6E6FF"
          v-model="tab"
        >
          <v-tabs-slider
            color="goldColor"
            style="border: 20px solid"
          ></v-tabs-slider>

          <v-tab
            href="#tab1"
            :style="tab === 'tab1' ? 'color: #4A154B' : 'color: grey'"
          >
            Αναζήτηση Βιβλίων Ανά Τμήμα
          </v-tab>
          <v-tab-item id="tab1" key="tab1">
            <CoursesAndBookgroups />
          </v-tab-item>
          <v-tab
            href="#tab2"
            :style="tab === 'tab2' ? 'color: #4A154B' : 'color: grey'"
          >
            Αναζήτηση με ID βιβλίου
          </v-tab>
          <v-tab-item id="tab2" key="tab2">
            <SearchByBookId />
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>

    <!-- Book Info Dialog - Single instance for entire app -->
    <book-info-dialog
      v-if="$store.getters.selectedBook != null"
      :book="$store.getters.selectedBook"
      :key="$store.getters.selectedBook.id"
    ></book-info-dialog>
  </v-container>
</template>

<script>
import SearchByBookId from "./SearchByBookId";
import CoursesAndBookgroups from "./CoursesAndBookgroups.vue";
import BookInfoDialog from "./BookInfoDialog.vue";

export default {
  name: "Home",
  components: { CoursesAndBookgroups, SearchByBookId, BookInfoDialog },
  data() {
    return {
      tab: "tab1",
    };
  },
};
</script>

<style scoped>
::v-deep .v-tabs {
  border-radius: 20px 20px 0 0 !important;
}

::v-deep .v-window {
  height: calc(100vh - 160px);
  overflow-y: auto;
  border-radius: 0 0 20px 20px !important;
}
</style>
